import PageLayout from '@/components/Common/PageLayout';
import UserRoleMap from '@/components/Common/UserRoleMap';
import ShUserAvatarUpload from '@/components/Helpers/ShUserAvatarUpload';

// @vue/component
export default {
  name: 'UserProfileHeader',

  components: { ShUserAvatarUpload, PageLayout, UserRoleMap },

  props: {
    user: {
      type: Object,
      default: () => ({
        login: 'login',
        email: 'email@email.com',
        name: 'Name',
        last_name: 'LastName',
        avatar: null,
        role: 'user',
      }),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    async handleChangeUserAvatar(avatarUrl) {
      if (!avatarUrl) return;
      
      this.$set(this.user, 'avatar', avatarUrl);
      
      const params = {
        avatar: avatarUrl,
        user: this.user.user_uuid,
      };
      await this.$store.dispatch('user/updateUser', params);
      await this.$store.dispatch('authorization/checkIfUserSessionExists', { endpoint: '/authorization/checkIfUserSessionExist' });
    },
  },
};
